var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInclusion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3321 18.1141C28.3321 16.9348 29.2879 15.9788 30.4669 15.9788H33.8652C35.0442 15.9788 36 16.9348 36 18.1141V21.5131C36 22.6923 35.0442 23.6483 33.8652 23.6483H30.4669C29.2879 23.6483 28.3321 22.6923 28.3321 21.5131V18.1141Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33126 22.0712L6.42097 19.7716L16.3394 27.1258L14.2497 29.4254L4.33126 22.0712Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5855 19.9016L31.6752 22.2012L21.7568 29.5554L19.667 27.2558L29.5855 19.9016Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1661 27.0835C14.1661 25.9042 15.1218 24.9482 16.3009 24.9482H19.6991C20.8782 24.9482 21.8339 25.9042 21.8339 27.0835V30.4825C21.8339 31.6617 20.8782 32.6177 19.6991 32.6177H16.3009C15.1218 32.6177 14.1661 31.6617 14.1661 30.4825V27.0835Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.1141C0 16.9348 0.955784 15.9788 2.1348 15.9788H5.53307C6.71209 15.9788 7.66787 16.9348 7.66787 18.1141V21.5131C7.66787 22.6923 6.71209 23.6483 5.53307 23.6483H2.1348C0.955784 23.6483 0 22.6923 0 21.5131V18.1141Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3265 5.11603L25.8958 4.14859C25.4999 3.88192 24.9575 3.98425 24.6926 4.37494L17.6793 14.6633L14.4563 11.4571C14.1197 11.1222 13.5711 11.1222 13.2344 11.4571L12.0094 12.6757C11.6728 13.0106 11.6728 13.5563 12.0094 13.8943L16.9655 18.8246C17.2429 19.1005 17.6793 19.3114 18.072 19.3114C18.4648 19.3114 18.8606 19.0664 19.1162 18.6974L27.5571 6.30983C27.8252 5.91913 27.7223 5.3827 27.3265 5.11603Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclusion);
export default __webpack_public_path__ + "static/media/Inclusion.a90f7f8eb146b927f4b1b1d1d1ec2acb.svg";
export { ForwardRef as ReactComponent };